import React from "react";
import { Navigate, useParams } from "react-router";

import FacilityDetail from "./FacilityDetail";
import LoadingSpinner from "../../common/LoadingSpinner";

import { useGetFacility } from "../../utils/useFacility";
import { useMetaData } from "../../utils/useMetaData";

const FacilityDetailContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const {
    items: { facilities, related_facilities },
    isLoading,
  } = useGetFacility({ id });

  const switchTabDisplay = (name: string, prefecture?: string) => {
    return prefecture ? `${name} (${prefecture})` : name;
  };

  useMetaData(
    facilities[0]
      ? {
          title: switchTabDisplay(facilities[0].name, facilities[0].prefecture),
          description: `${switchTabDisplay(
            facilities[0].name,
            facilities[0].prefecture
          )}の施設情報です。営業時間、利用料金、座席数、アクセスなど情報満載！写真で施設内の雰囲気もバッチリ分かる！全国のeスポーツ施設・カフェ情報はSELeCTでチェック！`,
          imgUrl: facilities[0].imgs?.[0]?.medium.url ?? "",
        }
      : undefined
  );

  if (isLoading === true) {
    return <LoadingSpinner space={1} />;
  } else if (facilities && facilities.length && facilities[0].id == id) {
    return (
      <FacilityDetail
        {...facilities[0]}
        relatedFacilities={related_facilities}
      />
    );
  } else {
    return <Navigate to="/404" replace />;
  }
};

export default FacilityDetailContainer;
